// src/api/productApi.js
import api from './api';

export const getProducts = () => {
  return api.get('/products');
};

export const createProduct = (formData) => {
  return api.post('/Products', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const updateProduct = (id, formData) => {
  return api.put(`/Products/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const deleteProduct = (SKU) => {
  return api.delete(`/Products/${SKU}`);
};

export const addProductQuantity = (SKU, payload) => {
  return api.put(`/Products/sku/${SKU}/add`, payload);
};

export const removeProductQuantity = (SKU, payload) => {
  return api.put(`/Products/sku/${SKU}/remove`, payload);
};

export const getProductBySKU = (SKU) => {
  return api.get(`/Products/sku/${SKU}`);
};
